import { render, staticRenderFns } from "./SuperTable.vue?vue&type=template&id=583c19f8&scoped=true"
import script from "./SuperTable.vue?vue&type=script&lang=js"
export * from "./SuperTable.vue?vue&type=script&lang=js"
import style0 from "./SuperTable.vue?vue&type=style&index=0&id=583c19f8&prod&lang=sass&scoped=true"
import style1 from "./SuperTable.vue?vue&type=style&index=1&id=583c19f8&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583c19f8",
  null
  
)

export default component.exports